import { DefaultModel } from "../defaultModel";

export const DoublePivotModel = DefaultModel.extend({
    defaults: () => ({
        ...DefaultModel.prototype.defaults,
        widgetType: "doublePivot"
    }),
    
    isSummaryEnabled() {
        return this.subtypeModel.get("doublePivot").summary.enabled;
    },
    
    showBadgeInTabNavi() {
        return this.subtypeModel.get("doublePivot").showBadgeInTabNavi;
    },
    
    changeChartType(chart) {
        this.set("options", {
            ...this.get("options"),
            bodyType: chart
        });
    }
});
